import { getIdToken } from 'firebase/auth';
import Pako from 'pako';

import { store } from '../App/store';

// export const apiBaseUrl = "http://localhost:8080";
export const apiBaseUrl = "https://api.nilgun.com.tr";

let csrfToken: string, idToken: string | undefined;

export const requestAsync = async (
  path: string,
  method: "GET" | "POST",
  body?: any
) => {
  if (body !== undefined && typeof body !== "string") {
    body = JSON.stringify(body);
  }

  let ignoreToken = path.startsWith("/no-auth/");
  let gzipped = false;

  if (body && body.length > 1024) {
    body = await Pako.gzip(body);
    gzipped = true;
  }

  while (true) {
    if (!idToken && !ignoreToken) {
      const { user } = store.getState().auth;

      if (user) {idToken = await getIdToken(user);}
      else {throw new Error("user is not logged in");}
    }

    const reqHeaders = new Headers();
    reqHeaders.set("content-type", "application/json");
    reqHeaders.set("x-csrf-token", csrfToken);
    if (!ignoreToken) {
      reqHeaders.set("x-id-token", idToken!);
    }

    if (gzipped) {
      reqHeaders.set("content-encoding", "gzip");
    }

    const res = await fetch(apiBaseUrl + path, {
      cache: "no-cache",
      method,
      body,
      headers: reqHeaders,
    });

    if (res.status >= 200 && res.status < 300) {
      const contentType = res.headers.get("content-type")?.split(";")?.[0];

      switch (contentType) {
        case "application/json":
          return res.json();
        case "image/png":
        case "application/pdf":
          return res.blob();
        default:
          throw `invalid contentType ${contentType}`;
      }
    } else {
      if (res.status === 401) {
        idToken = undefined;
      } else if (res.status === 403) {
        const reason = await res.json();

        if (reason.code === "invalid-csrf-token") {
          csrfToken = reason.csrf;
        } else {
          throw new Error(reason.message || reason.code);
        }
      } else {
        let json;

        try {
          json = await res.json();
        } catch (e) {
          console.error(e);
        }

        throw json ? json.message : `HTTP ${res.status}`;
      }
    }
  }
};

export const getAsync = (path: string) => requestAsync(path, "GET");
export const postAsync = (path: string, data: any) =>
  requestAsync(path, "POST", data);
